package com.bikompanion.data

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import com.bikompanion.domain.DeviceTimeZone
import com.bikompanion.domain.di.AppScope

@ContributesBinding(AppScope::class)
@Inject
class DeviceTimeZoneImpl : DeviceTimeZone {
    override fun id(): String? = systemTimeZoneId()?.takeIf { it.isNotBlank() }
}

internal expect fun systemTimeZoneId(): String?
